export default function isLetterOrNumberOrSpecial(str: string) {
  // This regex checks for alphanumeric characters and selected special characters.
  return /^[a-zA-Z0-9,./[\]!@#$%^&*()_+={};:'"|<>?~-]$/.test(str)
}
